import type { UploadRef } from '@pfe/design-renderer'

/** DataTransfer-Typ für Projektbilder, die aus dem Bilder-Panel auf die Bühne gezogen werden (JSON: UploadRef). */
export const DESIGN_UPLOAD_MIME = 'application/x-pfe-design-upload'

// Fallback: Safari/Firefox liefern eigene MIME-Typen in dragover nicht immer zuverlässig –
// innerhalb der Seite merken wir uns das gezogene Bild zusätzlich hier.
let dragged: UploadRef | null = null
export function setDraggedUpload(upload: UploadRef | null) { dragged = upload }
export function getDraggedUpload(): UploadRef | null { return dragged }
